import React from 'react'
import "./FullScreenLoad.css"
export default function FullScreenLoad() {
  return (
    <div className='full'>
    </div>
  )
}
